import type { FindAJobDropdownData } from '#/components/FindAJobDropdown/types/FindAJobDropdownData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/internships/routing/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';

export const findAJobDropdownDataEn: FindAJobDropdownData = {
  search: {
    title: 'Search',
    items: [
      {
        type: 'job',
        title: 'Jobs',
        href: searchGetJobsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'internship',
        title: 'Internships',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'org',
        title: 'Organizations',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.EN }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        type: 'salary-explorer',
        title: 'Nonprofit Salary Explorer',
        description:
          'Crowdsourced compensation data in the nonprofit sector. Insights for job seekers and employers.',
        href: '/nonprofit-salary-explorer',
      },
      {
        type: 'career-advice',
        title: 'Career Advice',
        description:
          'Informative and practical resources to help guide you throughout your social-impact career.',
        href: '/en/careers',
      },
    ],
  },
};
